export default "__VITE_ASSET__3870ae3f__"